import clsx from 'clsx';

type LegalInformationHeadingProps = {
  isDesktop: boolean;
  title: string;
};

export const LegalInformationHeading = ({
  isDesktop,
  title,
}: LegalInformationHeadingProps) => (
  <h2 className={clsx(isDesktop ? 'heading1' : 'heading2')}>
    {title}
  </h2>
);
